import types from './actionsTypes';

const initialState = {
  configurationData: []
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_CONFGURATION_DATA:
      return {
        ...state,
        configurationData: action.payload,
      };

    default:
      return state;
  }
}